import { render, staticRenderFns } from "./SOTracking.vue?vue&type=template&id=2001c4ba"
import script from "./SOTracking.vue?vue&type=script&lang=js"
export * from "./SOTracking.vue?vue&type=script&lang=js"
import style0 from "./SOTracking.vue?vue&type=style&index=0&id=2001c4ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports